<div class="side-bar  bottom-0 start-0 z-index py-3 z-2 px-2 top-90 col-lg-2" [class.hide]="!showSidebar">
    <!--main navigation-->
  
    <a tabindex="1" class="text-decoration-none d-block px-2 mb-2 py-1 rounded-1" routerLinkActive="active" :routerLink="/dashboard">
        <img src="./images/navigation/dashboard.svg"> Dashboard
    </a>
  
  
     <a tabindex="1" class="text-decoration-none d-block px-2 mb-2 py-1 rounded-1" [routerLinkActive]="'active'"
      [routerLinkActiveOptions]="{ exact: false }"
      [routerLink]="['/sales']">
      <img src="./images/navigation/staff.svg"> Manage Sales
  </a>

  <a tabindex="1" class="text-decoration-none d-block px-2 mb-2 py-1 rounded-1"  [routerLinkActive]="'active'"
      [routerLinkActiveOptions]="{ exact: false }"
      [routerLink]="['/applications']">
      <img src="./images/navigation/applicationIcon.svg"> Sales Applications
  </a>

    <a tabindex="1" class="text-decoration-none d-block px-2 mb-2 py-1 rounded-1"  [routerLinkActive]="'active'"
      [routerLinkActiveOptions]="{ exact: false }"
      [routerLink]="['/offers']">
      <img src="./images/navigation/offersIcon.svg"> Offers
  </a>
  <a tabindex="1" class="text-decoration-none d-block px-2 mb-2 py-1 rounded-1"  [routerLinkActive]="'active'"
      [routerLinkActiveOptions]="{ exact: false }"
      [routerLink]="['/assessment']">
      <img src="./images/navigation/question.svg"> Seller Assessment
  </a>
   <a tabindex="1" class="text-decoration-none d-block px-2 mb-2 py-1 rounded-1" 
      [routerLinkActive]="'active'"
      [routerLinkActiveOptions]="{ exact: false }"
      [routerLink]="['/extend-booking']">
      <img src="./images/extend-booking/extend.svg"> Extend Booking
  </a>
    <a tabindex="1" class="text-decoration-none d-block px-2 mb-2 py-1 rounded-1" routerLinkActive="active" :routerLink="/message/main-page">
      <img src="./images/navigation/messages.svg"> Message
  </a>
   <a tabindex="1" class="text-decoration-none d-block px-2 mb-2 py-1 rounded-1"  [routerLinkActive]="'active'"
      [routerLinkActiveOptions]="{ exact: false }"
      [routerLink]="['/faq']">
      <img src="./images/faq/faq.svg"> FAQ
  </a>

  
  
    <div style="margin-top:124px">
        <span class="other gray mb-3 fw-bold mt-4 d-block">other</span>
        <!-- <a tabindex="1" class="text-decoration-none d-block px-2 mb-2 py-1 rounded-1">
            <img src="./images/navigation/help.svg"> Help
        </a> -->
  
            <!-- <a tabindex="1" class="text-decoration-none d-block px-2 mb-2 py-1 rounded-1" :routerLink="/admins" routerLinkActive="active">
                <img src="./images/navigation/setting.svg"> Settings
            </a> -->
       
           <a tabindex="1" class="text-decoration-none d-block px-2 mb-2 py-1 rounded-1" style="cursor: pointer" (click)="logoutModal()">
          <img src="./images/navigation/logout.svg"> Logout
      </a>
  
    </div>
  </div>
  
  <!-- sidebar-menu  -->
  
  
 
  
  
  <div class="modal" tabindex="-1" role="dialog"  [ngStyle]="{'display':display}">
  <div class="modal-dialog modal-dialog-centered" role="document" style="width: 400px;">
        <div class="modal-content">
              <div class="modal-header pb-0 mb-0 d-flex justify-content-end">
                <button type="button" class="close border-0" aria-label="Close" #closebutton (click)="onCloseHandled()">
                  <img src="./images/navigation/close2.svg" alt="">
                </button>
                  </div>
           <div class="modal-body text-center my-0 py-0">
                  <span><img src="./images/navigation/logoutM.svg" alt=""></span>
                  <h5>Logout</h5>
                  <p class="text-muted ">Are you sure you want to logout? </p>
            </div>
                  <div class="modal-footer text-center mx-auto mt-0 pt-0 mb-2">
                    <button type="button" class="btn btn-delete mx-2" data-bs-dismiss="modal" (click)="onCloseHandled()">Cancel</button>
                    <button type="button" class="btn btn-color mx-2" id="closeModal" (click)="onSubmitModal2()" >Logout</button>
                  </div>
     </div>
      </div>
  </div>
  